<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.review') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.review') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" data-toggle="modal" :data-target="'#' + objectModalName.auditTemplate">Audit Aufgabe erstellen</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <div class="row mt-5">
            <div class="col-6">
              <div class="note-title">
                <h4>erstellte Maßnahmen für Audit/Review</h4>
              </div>
              <div id="ct" class="note-container note-grid" style="background-color: white; padding-top: 18px;">
                <div class="note-item all-notes" :class="{'note-important': taskInCurrentYear(task.due_date) === 'current-year', 'note-work': taskInCurrentYear(task.due_date) === 'last-year'}" v-for="task in auditTasks" :key="task.id">
                  <div class="note-inner-content">
                    <div class='pin' :class="{'pin-yellow': taskInCurrentYear(task.due_date) === 'current-year', 'pin-red': taskInCurrentYear(task.due_date) === 'last-year', 'pin-blue': taskInCurrentYear(task.due_date) === 'next-year'}"></div>
                    <div class="note-content">
                      <p class="note-title">{{ task.remarks }}</p>
                      <p class="meta-time">{{ task.due_date }}</p>
                      <div class="note-description-content">
                        <p>{{ task.description }}</p>
                      </div>
                    </div>
                    <div class="note-action">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 edit-note" @click.prevent="editAuditTask(task.id)"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 delete-note" @click.prevent="deleteAuditTask(task.id)"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check close-note" @click.prevent="closeAuditTask(task.id)"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-6">
              <div class="note-title">
                <h4>eingestellte Audit/Review - Maßnahmen werden automatisch erstellt</h4>
              </div>
              <!-- Content Starts -->
              <DataTableDSMS
                title="Audits"
                fileName="Audits"
                modelName="audit"
                deleteURL="todos/v1/delete_audit/"
                editorPatchURL="todos/v1/patch_audit/"
                :columns="columns"
                :objects="audits"
                :exportColumns="[0, 1]"
                :allowEditAction="false"
                :extraActions="extraActions"
                @tableCreated="setTable"
                @editorCreated="setEditor"
                @callDrawback="drawCallbackFunctions"
                v-if="audits.length > 0"
              ></DataTableDSMS>
              <!-- /Content End -->
            </div>
          </div>
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->

    <!--modal section starts here-->
      <AuditTaskComponent @auditsCreated="auditCreated" />
      <TaskComponent origin="audit" :current-todo="currentTodo" :popup="true" @todoUpdated="updateTodo"></TaskComponent>
    </div>
  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import {mapGetters, mapMutations, mapState} from 'vuex';
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import { deepCopy, boolDisplay } from '@/utils/index.js';
  import {newTodo, objectModalName} from "@/utils/enums";
  import TaskComponent from "@/components/component/TodoComponent.vue";
  import AuditTaskComponent from "@/components/component/AuditTaskModalComponent.vue";
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";

  export default {
    components: {
      FingerPrintSpinner,
      DataTableDSMS,
      TaskComponent,
      AuditTaskComponent,
    },
    data() {
      return {
        auditTasks: [],
        audits: [],
        currentTodo: newTodo,
        currentAudit: null,
        objectModalName: objectModalName,
        templateTaskLoaded: false,
        noteType: {
          short: 'note-important',
          middle: 'note-fav',
          long: 'note-personal'
        },
        table: null,
        editor: null,
        columns: [
          {
            label: 'Name',
            name: 'name',
            type: 'text',
            enableEditor: true,
            definition: { data: "name" },
          },
          {
            label: 'Kurzbeschreibung',
            name: 'description',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "description" },
          },
          {
            label: 'Fragenkatalog',
            name: 'question_description',
            enableEditor: false,
            definition: { data: "question_description" },
          },
          {
            label: 'geplantes Startdatum',
            name: 'start_date',
            type: 'datetime',
            enableEditor: true,
            definition: { data: "start_date"},
          },
          {
            label: 'Häufigkeit',
            name: 'frequency',
            type: 'text',
            attr: {
              type: 'number'
            },
            enableEditor: true,
            definition: { data: "frequency", render: (data) => data === 1 ? 'jedes Jahr' : `alle ${data} Jahren` },
          },
          {
            label: 'Aufwand(Tage)',
            name: 'duration',
            type: 'text',
            attr: {
              type: 'number'
            },
            enableEditor: true,
            definition: { data: "duration", render: (data) => `${data} Tage` },
          },
        ],
      }
    },
    created() {
      this.getAuditTasks()
      this.getAudits()
    },
    computed: {
      ...mapState({
        accountid: state => state.account.accountid,
        user: state => state.user,
        account: state => state.account,
        departments: state => state.account.departments,
        dataTypes: state => state.account.dataTypes,
        systems: state => state.account.systems
      }),
      ...mapGetters(['selectDepartmentOptions', 'selectDataTypeOptions', 'selectSystemOptions']),
      auditQuestion() {
        let auditQuestionID = null;
        for (let i=0; i<this.auditTasks.length; ++i) {
          if (this.auditTasks[i].question) {
            auditQuestionID = this.auditTasks[i].question
            break
          }
        }
        return auditQuestionID
      }
    },
    mounted() {
    },
    updated ()
    {
      this.$nextTick(() => {
        if ($('.note-item').length > 0) {
          $('.note-item').each(function () {
            const degree = Math.random() * 5
            const signNumber = Math.random() < 0.5 ? -1 : 1
            $(this).css({
              '-webkit-transform': 'rotate(' + degree * signNumber + 'deg)',
              '-moz-transform': 'rotate(' + degree * signNumber + 'deg)',
              '-ms-transform': 'rotate(' + degree * signNumber + 'deg)',
              'transform': 'rotate(' + degree * signNumber + 'deg)',
            });
            $(this).attr('data-rotation', degree * signNumber)
          })
          $('.note-item').off('mouseenter').on('mouseenter', function (e) {
            // console.log($(this))
            // console.log($(e.target))
            // let dom$ = $(e.target)
            // dom$.stop()
            // if (!$(e.target).hasClass('note-item')) {
            //   dom$ = $(e.target).closest('.note-item')
            // }
            $(this).stop().css({
              '-webkit-transform': 'rotate (0deg) scale(1.1)',
              '-moz-transform': 'rotate(0deg) scale(1.1)',
              '-ms-transform': 'rotate(0deg) scale(1.1)',
              'transform': 'rotate(0deg) scale(1.1)'
            });
          })
          $('.note-item').off('mouseleave').on('mouseleave', function (e) {
            // let dom$ = $(e.target)
            // dom$.stop()
            // if (!$(e.target).hasClass('note-item')) {
            //   dom$ = $(e.target).closest('.note-item')
            // }
            // dom$.stop(true)
            const degree = $(this).data('rotation')
            $(this).stop().css({
              '-webkit-transform': 'rotate(' + degree + 'deg)',
              '-moz-transform': 'rotate(' + degree + 'deg)',
              '-ms-transform': 'rotate(' + degree + 'deg)',
              'transform': 'rotate(' + degree + 'deg)'
            });
          })
        }
      })
    },
    methods: {
      ...mapMutations({setEdit: "SET_EDIT", setModalDirty: 'SET_MODALDIRTY'}),
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      taskInCurrentYear(dateString) {
        const currentYear = String(new Date().getFullYear())
        if (dateString.substring(0,4) < currentYear) return 'last-year'
        if (dateString.substring(0,4) === currentYear) return 'current-year'
        return 'next-year'
      },
      updateTodo(todo) {
        const todoIndex = this.auditTasks.findIndex(task => task.id === todo.id)
        if (todoIndex === -1) {
          this.auditTasks.push(todo)
        } else {
          this.auditTasks[todoIndex] = todo
        }
        $(`#${objectModalName.task}`).modal('hide')
      },
      editAuditTask(todoId) {
        this.currentTodo = this.auditTasks.find(task => task.id === todoId)
        this.setEdit(true)
        $(`#${objectModalName.task}`).modal('show')
      },
      closeAuditTask(todoId) {
        this.$confirm(
          {
            message: `Sicher, dass diese Audit Maßnahme abgeschlossen ist?`,
            button: {
              no: 'Nein',
              yes: 'Ja'
            },
            callback: confirm => {
              if (confirm) {
                service.request({
                  url: `todos/v1/patch_audittask/${todoId}/`,
                  method: 'PUT',
                  responseType: 'json',
                  data: {"id": todoId,"status": "Abgeschlossen","modified_by": this.user.username,"customer": this.account.name}
                }).then((response) => {
                  const objectIndex = this.auditTasks.findIndex(obj => obj.id === todoId)
                  this.auditTasks.splice(objectIndex, 1)
                  this.$vToastify.success('Audit Maßnahme ist erfolgreich abgeschlossen!')
                }).catch((err) => {
                  console.log(err)
                })
              }
            }
          }
        )
      },
      deleteAuditTask(todoId) {
        this.$confirm(
          {
            message: `Sicher, dass diese Audit Aufgabe gelöscht wird?`,
            button: {
              no: 'Nein',
              yes: 'Ja'
            },
            callback: confirm => {
              if (confirm) {
                service.request({
                  url: `todos/v1/delete_audittask/${todoId}/`,
                  method: 'DELETE',
                  responseType: 'json'
                }).then(() => {
                  const todoIndex = this.auditTasks.findIndex(task => task.id === todoId)
                  this.auditTasks.splice(todoIndex, 1)
                  this.$vToastify.success(`Die Audit Aufgabe ist erfolgreich gelöscht!`)
                })
              }
            }
          }
        )
      },
      async getAuditTasks() {
        service.request({
          url: `todos/v1/audittasks/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.auditTasks = response.data;
        }).catch(function(err) {
          console.log(err)
        })
      },
      async getAudits() {
        service.request({
          url: `todos/v1/audits/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.audits = response.data;
        }).catch(function(err) {
          console.log(err)
        })
      },
      auditTasksCreated(tasks) {
        this.auditTasks = [...this.auditTasks, ...tasks]
      },
      auditCreated(audits) {
        const createdAudits = audits.created
        const updatedAudits = audits.updated
        if (createdAudits.length > 0) {
          this.audits = [...this.audits, ...createdAudits]
          this.getAuditTasks()
        }
        if (updatedAudits.length > 0) {
          updatedAudits.forEach(audit => {
            const auditIndex = this.audits.findIndex(item => item.id === audit.id)
            this.audits[auditIndex] = audit
          })
          this.table.clear().rows.add(this.audits).draw()
        }
      },
      extraActions(data) {
        return `<a class="dropdown-item generate-task" href="#" data-object-id="${data.id}">Aufgabe erstellen</a>`
      },
      drawCallbackFunctions() {
        const that = this
        $('.generate-task').off('click').on('click', (e) => {
          e.preventDefault()
          const objectId = $(e.target).data('object-id');
          const startNewTask = () => {
            that.currentAudit = that.audits.filter(aud => aud.id === parseInt(objectId))[0]
            that.currentTodo = deepCopy(newTodo)
            that.currentTodo.customer = that.account.name
            that.currentTodo.modified_by = that.user.username
            that.currentTodo.description = that.currentAudit.description
            that.currentTodo.object_id = that.currentAudit.id
            that.currentTodo.model = 'audit'
            that.currentTodo.origin = 'audit'
            that.currentTodo.start_date = that.currentAudit.start_date
            that.currentTodo.due_date = that.currentAudit.due_date
            that.currentTodo.question = that.currentAudit.question
            that.currentTodo.assigned_to_char = that.user.username
            that.currentTodo.priority = that.currentAudit.question_priority
            that.currentTodo.remarks = that.currentAudit.name
            that.setEdit(true)
            $(`#${objectModalName.task}`).modal('show')
          }
          if (that.auditTasks.some(task => task.object_id === parseInt(objectId))) {
            this.$confirm(
              {
                message: 'Eine Aufgabe ist bereits für das Audit generiert. Sollte eine neue erstellt werden?',
                button: {
                  no: 'Nein',
                  yes: 'Ja'
                },
                callback: confirm => {
                  if (confirm) {
                    startNewTask()
                  }
                }
              }
            )
          } else {
            startNewTask()
          }
        })
      }
    }
  }
</script>
<style scoped src="@/assets/css/notes.css">
</style>
